import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { HbtInputTextComponent } from './components/hbt-input-text/hbt-input-text.component';
import { HbtButtonComponent } from './components/hbt-button/hbt-button.component';
import { NzInputModule } from 'ng-zorro-antd/input';
import { FormsModule } from '@angular/forms';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { SpecialInputDirective } from './directive/special-input.directive';
import { NumbericDirective } from './directive/numberic.directive';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { StepUp2faModalComponent } from './components/step-up-2fa-modal/step-up-2fa-modal.component';



@NgModule({
  declarations: [HbtInputTextComponent, HbtButtonComponent, SpecialInputDirective, NumbericDirective, StepUp2faModalComponent],
  exports: [HbtInputTextComponent, HbtButtonComponent, SpecialInputDirective, NumbericDirective],
  imports: [
    CommonModule,
    NzInputModule,
    FormsModule,
    NzAutocompleteModule,
    NzInputNumberModule,
    NzIconModule,
    NzButtonModule
  ],
  providers: [DecimalPipe]
})
export class SharedModule { }
